export const moneyFormat = (total: number) => {
  const formatter = Number(total?.toFixed(2)).toLocaleString("jp-JP")
  return formatter
}
